module.exports = __webpack_public_path__ + "7994a226a2fe21d57d73f554de588555.MP3";